import AuditUpload from './AuditUpload';
import AuditList from "./AuditList";

export default {
    list: AuditList,
    create: AuditUpload
};
